import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { ProductDetails, ProductDetailsScreen } from 'types/state';
import { SidebarModalSectionComponent } from 'design/sidebarModal';
import { TextComponent } from 'design/text/textComponents';
import {
  SidebarModalNavigationControlComponent,
  SidebarModalNavigationLayoutComponent,
} from 'design/sidebarModalNavigation';

type Props = {
  details: ProductDetails;
  activeScreen: ProductDetailsScreen;
  onSummaryTabClick(): void;
  onArchiveTabClick(): void;
};

export const ProductManagerContent: React.FC<Props> = (props) => {
  const {
    details,
    activeScreen,
    children,
    onSummaryTabClick,
    onArchiveTabClick,
  } = props;

  const { product } = details;

  const { productDetails: ownDictionary } = useIntlDictionary();

  return (
    <>
      <SidebarModalSectionComponent
        theme="head"
        content={
          <TextComponent size="mpp" weight="medium">
            {product.name}
          </TextComponent>
        }
        actions={null}
        navigation={
          <SidebarModalNavigationLayoutComponent>
            <SidebarModalNavigationControlComponent
              onPress={onSummaryTabClick}
              active={activeScreen === 'SUMMARY'}
            >
              <TextComponent>
                {ownDictionary.tabs.summaryTabTitle}
              </TextComponent>
            </SidebarModalNavigationControlComponent>
            <SidebarModalNavigationControlComponent
              onPress={onArchiveTabClick}
              active={activeScreen === 'ARCHIVE'}
            >
              <TextComponent>
                {ownDictionary.tabs.archiveTabTitle}
              </TextComponent>
            </SidebarModalNavigationControlComponent>
          </SidebarModalNavigationLayoutComponent>
        }
      />
      {children}
    </>
  );
};
